/* =====================================================
   CAMPOS GENERALES (compartidos por varios formatos)
===================================================== */

export const CAMPOS_GENERALES_FASE = [
	"nombre_completo",
	"documento_identidad",
	"lugar_expedicion",
	"fecha_registro",
	"numero_contacto",
	"correo_electronico",
];


/* =====================================================
   CAMPOS ESPECÍFICOS POR FORMATO DE FASE
===================================================== */

export const CAMPOS_ESPECIFICOS_FASE = {
	F1_001: [
		"tipo_usuario",
		"descripcion_emergencia",
		"atencion_fisica",
		"remision_hospitalaria",
		"atencion_mental",
		"articulo_externa",
		"entidad_externa",
		"otra_entidad_externa",
		"tp_responsable",
	],

	F2_002: [
		"rol_usuario",
		"decision_activacion",
		"tp_responsable",
	],

	F2_003: [
		"calidad_entrevistado",
		"es_menor_edad",
		"nombre_representante",
		"parentesco_representante",
		"cc_representante",
		"expedicion_representante",
		"contacto_representante",
		"nombre_autorizado",
		"cc_autorizado",
		"contacto_autorizado",
		"tp_responsable",
	],

	F2_004: [
		"es_menor_edad",
		"nombre_representante",      
		"cc_representante",        
		"expedicion_representante",   
		"nombre_autorizado",         
		"cc_autorizado",             
		"tp_responsable",
		"lugar_expedicion"             
		],

	F2_005: [
		"fecha_nacimiento",
		"edad",
		"programa",
		"semestre",
		"estado_civil",
		"genero",
		"direccion_residencia",
		"pertenece_grupo_priorizado",
		"nombre_grupo_priorizado",
		"rol_persona",
		"fecha_entrevista",
		"fecha_firma_transcripcion",
		"relato_hechos",
		"numero_cuartillas",
		"tp_responsable"
	],

	F3_006: [
		"nombre_participante",
		"medidas_preventivas",
		"remision_conciliacion",
		"compromisos_acuerdo",
		"tp_responsable"
	],

	F5_007: [
		"nombre_afectado",
		"edad",
		"identidad_genero",
		"contacto",
		"correo",
		"voluntad_restaurativa",
		"medida_proteccion",
		"acompanamiento_psico",
		"obj_reconocimiento",
		"obj_reparacion",
		"obj_norepeticion",
		"obj_vinculos",
		"obj_comunitario",
		"otros_objetivos",
		"medidas_restaurativas",
		"observaciones_evaluacion",
		"tp_responsable"
	],

F5_008: [
    "nombre_ofensor",
    "edad_ofensor",
    "genero_ofensor",
    "vinculo_univeritario",
    "contacto_ofensor",
    "correo_electronico",
    "inf_proceso_activado",
    "inf_medidas_construidas",
    "inf_finalidad_limites",
    "inf_voluntariedad",
    "comprende_objetivo",
    "acepta_proceso_restaurativo",
    "observaciones_ofensor",
    "nombre_completo", 
    "documento_identidad",
    "lugar_expedicion",
    "identidad_genero",
	"tp_responsable"
],

	F6_009: [
		"resumen_gestion",
		"verificacion_compromisos",
		"situacion_actual",
		"activacion_fase1",
		"activacion_medidas_proteccion",
		"tp_responsable"
	],

	T_1: [
		"rol_interesado",
		"nombre_interesado",
		"documento_interesado",
		"fecha_ultima_comunicacion",
		"tp_responsable"
	],

	T_2: [
		"rol_interesado",
		"nombre_interesado",
		"documento_interesado",
		"fecha_ultima_comunicacion",
		"tp_responsable"
	],

	T_3: [
		"nombre_desistente",
		"documento_identidad",
		"lugar_expedicion_representante",
		"lugar_expedicion_desistente",
		"contacto_desistente",
		"es_menor",
		"nombre_representante",
		"parentesco_representante",
		"documento_representante",
		"tp_responsable"
	],

	T_4: [
		"fecha_intervencion",
		"rol_caso",
		"cargo_profesional",
		"tema_abordado",
		"compromisos_asumidos",
		"observaciones_adicionales",
		"tp_responsable",
		"fecha_intervencion",
		"responsable_atencion",
		"tp_responsable"
	],

	T_5: [
		"fecha_comunicacion",
		"tipo_interesado",
		"nombre_destinatario",
		"recomendaciones_cierre",
		"tp_responsable"
	],
};

/* =====================================================
   VALIDACIONES DECLARATIVAS POR PASO
===================================================== */

export const VALIDACIONES_FASE = {
	F1_001: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "No. de documento" },
				{ key: "lugar_expedicion", label: "Lugar de Expedición" },
				{ key: "tipo_usuario", label: "Tipo Usuario" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "descripcion_emergencia", label: "Descripción sintética de la emergencia" }
			]
		},
		2: {
			required: [
				{ key: "atencion_fisica", label: "Atención en salud física de emergencia" },
				{ key: "remision_hospitalaria", label: "Remisión para atención hospitalaria" },
				{ key: "atencion_mental", label: "Atención en salud mental de emergencia" },
				{ key: "articulo_externa", label: "Requiere articulación con entidades externas" }
			],
			conditionalRequired: [
				{
					when: { key: "articulo_externa", isSi: true },
					fields: [{ key: "entidad_externa", label: "Entidad externa", message: "Selecciona la entidad externa." }]
				},
				{
					when: { key: "entidad_externa", equals: "OTRA" },
					fields: [{ key: "otra_entidad_externa", label: "Otra entidad externa", message: "Ingresa la otra entidad externa." }]
				}
			]
		}
	},
	F2_002: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "No. de documento" },
				{ key: "lugar_expedicion", label: "Lugar de Expedición" },
				{ key: "rol_usuario", label: "Calidad del Usuario" },
				{ key: "numero_contacto", label: "Número de contacto" }
			]
		},
		2: {
			required: [{ key: "decision_activacion", label: "Decisión de activación" }]
		}
	},
	F2_003: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "No. de documento" },
				{ key: "lugar_expedicion", label: "Lugar de expedición" },
				{ key: "calidad_entrevistado", label: "Calidad del entrevistado" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "es_menor_edad", label: "Confirmación de menor de edad" }
			],
			conditionalRequired: [
				{
					when: { key: "es_menor_edad", isSi: true },
					fields: [
						{ key: "nombre_representante", label: "Nombre del representante" },
						{ key: "parentesco_representante", label: "Parentesco del representante" },
						{ key: "cc_representante", label: "CC. representante" },
						{ key: "expedicion_representante", label: "Lugar de expedición del representante" },
						{ key: "contacto_representante", label: "Contacto del representante" }
					]
				},
				{
					when: { key: "es_menor_edad", notSi: true },
					fields: [
						{ key: "nombre_autorizado", label: "Nombre de la persona autorizada" },
						{ key: "cc_autorizado", label: "CC. autorizado" },
						{ key: "contacto_autorizado", label: "Contacto autorizado" }
					]
				}
			]
		}
	},
	F2_004: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "documento_identidad", label: "No. de documento" },
				{ key: "lugar_expedicion", label: "Donde fue expedido" },
				{ key: "es_menor_edad", label: "Confirmación de menor de edad" }
			],
			conditionalRequired: [
				{
					when: { key: "es_menor_edad", isSi: true },
					fields: [
						{ key: "nombre_representante", label: "Nombre del representante" },
						{ key: "cc_representante", label: "CC. representante" },
						{ key: "expedicion_representante", label: "Expedición del representante" }
					]
				},
				{
					when: { key: "es_menor_edad", notSi: true },
					fields: [
						{ key: "nombre_autorizado", label: "Nombre de la persona autorizada" },
						{ key: "cc_autorizado", label: "CC. autorizado" }
					]
				}
			]
		}
	},
	F2_005: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "Documento de identidad" },
				{ key: "lugar_expedicion", label: "Lugar de expedición" },
				{ key: "fecha_nacimiento", label: "Fecha de nacimiento" },
				{ key: "programa", label: "Programa / Dependencia" },
				{ key: "semestre", label: "Semestre" },
				{ key: "estado_civil", label: "Estado civil" },
				{ key: "genero", label: "Género" },
				{ key: "pertenece_grupo_priorizado", label: "Grupo priorizado" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "correo_electronico", label: "Correo electrónico" },
				{ key: "direccion_residencia", label: "Dirección de residencia" },
				{ key: "rol_persona", label: "Rol de la persona" },
				{ key: "fecha_entrevista", label: "Fecha de la entrevista" },
				{ key: "fecha_firma_transcripcion", label: "Fecha de firma de la transcripción" }
			],
			conditionalRequired: [
				{
					when: { key: "pertenece_grupo_priorizado", isSi: true },
					fields: [{ key: "nombre_grupo_priorizado", label: "Nombre del grupo priorizado" }]
				}
			]
		},
		2: {
			required: [
				{ key: "relato_hechos", label: "Relato de hechos" },
				{ key: "numero_cuartillas", label: "Número de cuartillas" }
			]
		}
	},
	F3_006: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "No. de documento" },
				{ key: "lugar_expedicion", label: "Lugar de expedición" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "fecha_registro", label: "Fecha" }
			]
		},
		2: {
			required: [
				{ key: "medidas_preventivas", label: "Medidas preventivas" },
				{ key: "remision_conciliacion", label: "Remisión para proceso conciliatorio" }
			],
			conditionalRequired: [
				{
					when: { key: "remision_conciliacion", isSi: true },
					fields: [{ key: "compromisos_acuerdo", label: "Compromisos del acuerdo" }]
				}
			]
		}
	},
	F5_007: {
		1: {
			required: [
				{ key: "nombre_afectado", label: "Nombre de la persona afectada" },
				{ key: "documento_identidad", label: "No. de documento de Identidad" },
				{ key: "lugar_expedicion", label: "Lugar de expedición" },
				{ key: "edad", label: "Edad" },
				{ key: "identidad_genero", label: "Identidad de género" },
				{ key: "contacto", label: "Teléfono / Medio de contacto" },
				{ key: "voluntad_restaurativa", label: "Voluntad de participar en medida restaurativa" }
			],
			conditionalRequired: [
				{
					when: { key: "voluntad_restaurativa", isSi: true },
					fields: [
						{ key: "medida_proteccion", label: "¿Le fue emitida medida de protección?" },
						{ key: "acompanamiento_psico", label: "¿Cuenta con acompañamiento psicosocial activo?" }
					]
				}
			]
		},
		2: {
			atLeastOne: [
				{
					fields: ["obj_reconocimiento", "obj_reparacion", "obj_norepeticion", "obj_vinculos", "obj_comunitario", "otros_objetivos"],
					errorKeys: ["objetivos_intervencion", "otros_objetivos"],
					message: "Selecciona al menos un objetivo o completa \"Otros objetivos / Observaciones\".",
					mode: "truthy"
				}
			],
			arrayRequired: [
				{
					key: "medidas_restaurativas",
					minItems: 1,
					errorKey: "medidas_restaurativas",
					message: "Debe agregar al menos una medida restaurativa.",
					itemErrorKeyTemplate: "medida_${index}_${field}",
					itemFields: [
						{ key: "descripcion", message: "La descripción es obligatoria." },
						{ key: "responsable", message: "El responsable es obligatorio." },
						{ key: "fecha", message: "La fecha es obligatoria." },
						{ key: "seguimiento", message: "El seguimiento es obligatorio." }
					]
				}
			]
		},
		3: {
			required: [
				{ key: "observaciones_evaluacion", label: "Evaluación: Observaciones importantes para el proceso" }
			]
		}
	},
	F5_008: {
		1: {
			required: [
				{ key: "nombre_ofensor", label: "Nombre completo de la persona ofensora" },
				{ key: "documento_identidad", label: "No. de documento de Identidad" },
				{ key: "lugar_expedicion", label: "Lugar de expedición" },
				{ key: "numero_contacto", label: "Número de contacto" },
				{ key: "edad_ofensor", label: "Edad" },
				{ key: "identidad_genero", label: "Identidad de género" },
				{ key: "vinculo_univeritario", label: "Vínculo con la Universidad" },
				{ key: "contacto_ofensor", label: "Teléfono / medio de contacto" },
				{ key: "correo_electronico", label: "Correo electrónico" }
			]
		},
		2: {
			required: [
				{ key: "comprende_objetivo", label: "Comprende el objetivo del proceso" },
				{ key: "acepta_proceso_restaurativo", label: "Acepta participar en el proceso restaurativo" }
			],
			atLeastOne: [
				{
					fields: ["inf_proceso_activado", "inf_medidas_construidas", "inf_finalidad_limites", "inf_voluntariedad"],
					errorKey: "informacion_socializada",
					message: "Debes marcar al menos una opción de la información socializada.",
					mode: "si"
				}
			],
			conditionalRequired: [
				{
					when: { key: "acepta_proceso_restaurativo", equals: "SI" },
					fields: [
						{ key: "observaciones_ofensor", label: "Observaciones o compromisos iniciales del ofensor", message: "Cuando acepta participar, las observaciones son obligatorias." }
					]
				}
			]
		}
	},
	F6_009: {
		1: {
			required: [
				{ key: "resumen_gestion", label: "Resumen de la gestión surtida en la ruta" },
				{ key: "verificacion_compromisos", label: "Verificación de los compromisos adquiridos" },
				{ key: "situacion_actual", label: "Situación actual del interesado" }
			]
		},
		2: {
			required: [
				{ key: "activacion_fase1", label: "Activación de la fase 1. ATE. EMERGENCIA" },
				{ key: "activacion_medidas_proteccion", label: "Activación de la fase 6. MED. PROTECCIÓN" },
				{ key: "nombre_completo", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "Documento de Identidad" },
				{ key: "lugar_expedicion", label: "Lugar de Expedición" },
				{ key: "numero_contacto", label: "Número de contacto" }
			]
		}
	},
	T_1: {
		1: {
			required: [
				{ key: "rol_interesado", label: "Calidad del interesado" },
				{ key: "fecha_ultima_comunicacion", label: "Fecha última comunicación" }
			]
		}
	},
	T_2: {
		1: {
			required: [
				{ key: "rol_interesado", label: "Calidad del interesado" },
				{ key: "fecha_ultima_comunicacion", label: "Fecha última comunicación" }
			]
		}
	},
	T_3: {
		1: {
			required: [
				{ key: "nombre_desistente", label: "Nombre Completo" },
				{ key: "documento_identidad", label: "No. de Documento" },
				{ key: "lugar_expedicion_desistente", label: "Donde fue expedido" },
				{ key: "contacto_desistente", label: "Número de contacto" },
				{ key: "es_menor", label: "¿Es menor de edad?" }
			],
			conditionalRequired: [
				{
					when: { key: "es_menor", isSi: true },
					fields: [
						{ key: "nombre_representante", label: "Representante de (Él / la) estudiante" },
						{ key: "parentesco_representante", label: "Parentesco" },
						{ key: "documento_representante", label: "C.C. del Representante" },
						{ key: "lugar_expedicion_representante", label: "Expedida en" }
					]
				}
			]
		}
	},
	T_4: {
		1: {
			required: [
				{ key: "nombre_completo", label: "Nombre de la persona atendida" },
				{ key: "documento_identidad", label: "Documento de identidad" },
				{ key: "lugar_expedicion", label: "Lugar de expedición del documento" },
				{ key: "numero_contacto", label: "Contacto (Teléfono o Celular)" },
				{ key: "fecha_intervencion", label: "Fecha de la intervención" },
				{ key: "rol_caso", label: "Rol en el caso" },
				{ key: "responsable_atencion", label: "Profesional que brinda la psicoeducación" },
				{ key: "cargo_profesional", label: "Cargo" }
			]
		},
		2: {
			required: [
				{ key: "tema_abordado", label: "Tema abordado en la Psicoeducación" },
				{ key: "compromisos_asumidos", label: "Compromisos asumidos" },
				{ key: "observaciones_adicionales", label: "Observaciones adicionales" }
			]
		}
	},
	T_5: {
		1: {
			required: [
				{ key: "fecha_comunicacion", label: "Fecha de la comunicación" },
				{ key: "tipo_interesado", label: "Tipo de Interesado" },
				{ key: "nombre_destinatario", label: "Nombre del destinatario" }
			]
		}
	}
};


/* =====================================================
   GENERADOR DE ESTADO INICIAL PARA FASES
===================================================== */

// Campos que deben inicializarse como arrays
const CAMPOS_ARRAY = ["medidas_restaurativas"];

export const generarEstadoInicialFase = (tipoFormulario) => {
	const estado = {};

	CAMPOS_GENERALES_FASE.forEach((campo) => {
		estado[campo] = { valor: "" };
	});

	(CAMPOS_ESPECIFICOS_FASE[tipoFormulario] || []).forEach((campo) => {
		// Inicializar arrays vacíos para campos especiales
		if (CAMPOS_ARRAY.includes(campo)) {
			estado[campo] = { valor: [] };
		} else {
			estado[campo] = { valor: "" };
		}
	});

	return estado;
};

